import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/unitlink-general-types/unitlink/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchUnitlinkTenantsNoSuspense =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useQuery
